import { getLocalDateKey, getQuestScheduleDateKey } from './questScheduleDate';

export const isQuestWithinUtcRange = (quest, startOfTodayUTC, endOfTodayUTC) => {
  if (!quest?.start) {
    return false;
  }

  const questStartUTC = new Date(quest.start).getTime();
  return questStartUTC >= startOfTodayUTC && questStartUTC <= endOfTodayUTC;
};

export const buildVisibleTodayQuests = ({
  quests = [],
  todayDateKey,
  now = new Date(),
  fallbackTimezone = 'UTC',
  resolveQuestIcon,
}) => {
  const todaysQuests = quests.filter((quest) =>
    getQuestScheduleDateKey(quest) === (
      quest?.userTimezoneAtScheduling
        ? getLocalDateKey(now, quest.userTimezoneAtScheduling || fallbackTimezone)
        : todayDateKey
    )
    && quest?.type !== 'HealthKit'
  );

  return todaysQuests
    .map((quest) => ({
      ...quest,
      icon: resolveQuestIcon(quest),
    }))
    .sort((left, right) => {
      const leftRank = left.completed ? 2 : left.isLockedTeaser ? 1 : 0;
      const rightRank = right.completed ? 2 : right.isLockedTeaser ? 1 : 0;
      return leftRank - rightRank;
    });
};
